// extracted by mini-css-extract-plugin
module.exports = {"myOffers":"myOffers_myOffers__2rxFN","text":"myOffers_text__RyfU9","Loader":"myOffers_Loader__reHdy"};